<template>
  <div class="box"> 
    <div class="newsviews">
      <div class="tab">
        <router-link to="/">首页</router-link>>{{title}}
      </div>
      <div class="views">
        <ul>
          <router-link tag="li" v-for="item in realList" :key="item.id" :to="`/news/info/${item.plateid}/${item.uuid}`">
            <img v-if="item.picsrc" :src="`${IP_TEST}/uploads/${item.picsrc}`" alt="" width="262" height="158">
            <div v-else style="width:262px;height:158px;background:#F3F4F5;font-size:18px;color:#FFF;line-height:158px;text-align:center;">
              暂无图
            </div>
            <div>
              <h4>{{item.title}}</h4>
              <p>{{item.description}}</p>
              <div>
                <span class="addtime">{{item.addtime|filterdate}}</span>
                <span class="artvisits">{{item.artvisits}}</span>
                <span class="writer">作者:{{item.writer}}</span>
              </div>
            </div>
          </router-link>
        </ul>
      </div>
      <ul class="pages" v-if="sumPages">
        <li class="up" @click="upPage()"></li>
        <li @click="handlePage(index)" v-for="index in showPageNums" :class="index==pageIndex&&'show'" :key="index">
          {{index}}</li>
        <li class="next" @click="nextPage()"></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { IP_TEST } from '@/config'
import { getNewsViews, getSearch } from '@/request/get'
export default {
  name: "NewsViews",
  components: {
  },
  data() {
    return {
      plateId: this.$route.params.plateId||'',
      current: 1,
      list: [],
      realList: [],
      pageNum: 4,//每页条数
      sumPages: 0,//总页数
      pageIndex: 1,//当前页
      showPageNums:[1,2,3,4],//页码
      IP_TEST: IP_TEST
    }
  },
  filters: {
    filterdate(date) {
      return date.slice(0, 10).replace("-", "年").replace("-", "月")+"日";
    },
    filterPage(page) {
      if (page === 0) {
        return ""
      }
      return page
    }
  },
  computed: {
    title() {
      let { plates } = this.$store.state;
      if (this.plateId == "search") {
        return "搜索结果"
      }
      let arrs = plates.filter(item => item.uuid == this.plateId)
      return arrs.length === 0 ? "未配置" : arrs[0].name
    }
  },
  created() {
    if (this.plateId == "search") {
      this.getSearch();
    } else {
      this.getNewsViews();
    }
  },
  mounted() {
    this.toTop();
  },
  methods: {
    async getSearch() {
      let result = await getSearch(this.$route.query.keyWords);
      result = result.data;
      this.list = result || [];
      this.sumPages = Math.ceil(result.length / this.pageNum);
      this.handlePage(1);
    },
    async getNewsViews() {
      let result = await getNewsViews(this.plateId, this.current);

      result = result.data;
      this.list = result || [];
      this.sumPages = Math.ceil(result.length / this.pageNum);
      this.handlePage(1);
      
    },
    setShowPageNums() {
      let pageNum = this.pageNum;
      let pageIndex = this.pageIndex;
      if (pageIndex > pageNum) {
        this.showPageNums = [pageIndex-3, pageIndex-2, pageIndex-1, pageIndex];
      } else {
        this.showPageNums = [1, 2, 3, 4];
      } 
    },
    handlePage(pages) {
      let pageNum = this.pageNum;
      let sumPages = this.sumPages;
      pages = pages < 1 ? 1 : pages;
      pages = pages > sumPages ? sumPages : pages;
      this.pageIndex = pages;
      this.setShowPageNums();
      this.realList = this.list.filter((item, index) => {
        return pageNum * (pages - 1) <= index && index < pageNum * pages;
      })
    },
    upPage() {
      let pages = this.pageIndex - 1;
      this.handlePage(pages);
    },
    nextPage() {
      let pages = this.pageIndex + 1;
      this.handlePage(pages);
    },
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>
<style scoped>
.box{
  position: relative;
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
}
.newsviews{
  position: relative;
  width: 1200px;
  min-height: 1166px;
  margin: 0 auto;
  overflow: hidden;
}
.newsviews>.pages{
  position: relative;
  margin-top:9px;
  width: 1200px;
  height: 34px;
  display: flex;
  justify-content: end;
}
.newsviews>.pages>li{
  margin-right: 23px;
  width: 34px;
  height: 34px;
  border: 1px solid #EDEDED;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
  line-height: 34px;
  text-align: center;
}
.newsviews>.pages>li.up{
  background:url(/static/img/left.png) ;
  background-size: 34px 34px;
}
.newsviews>.pages>li.show{
  background: #306BCD;
  color: #FFFFFF;
}
.newsviews>.pages>li.next {
  background: url(/static/img/right.png);
  background-size: 34px 34px;
}
.newsviews .tab{
  margin: 27px 0 28px 0;
  width: 300px;
  height: 14px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 14px;
}
.newsviews .views{
  height: 796px;
}
.newsviews .views ul li{
  width: 1200px;
  height: 158px;
  padding-bottom: 41px;
  display: flex;
  justify-content: start;
}
.newsviews .views ul li>div{
  width: 938px;
  height: 158px;
  background-color: #fcfcfc;
}
.newsviews .views ul li>div>h4{
  padding: 15px 0 19px 24px;
  /* width: 413px; */
  height: 18px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 18px;
  overflow: hidden;
}
.newsviews .views ul li>div>p {
  padding-left: 25px;
  width: 905px;
  height: 39px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
  line-height: 20px;
  overflow: hidden;
}
.newsviews .views ul li>div>div {
  position: relative;
  padding-top:33px;
  padding-left: 26px;
  height: 15px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #BDBDBD;
  line-height: 15px;
}
.newsviews .views ul li>div>div>.addtime{
  position: relative;
  display: inline-block;
  height: 15px;
  line-height: 15px;
  padding-left:22px;
  padding-right: 29px;
}
.newsviews .views ul li>div>div>.addtime::before {
  content:'';
  display: inline-block;
  position: absolute;
  top:0;
  left: 0;
  width: 15px;
  height: 15px;
  background: url(/static/img/time_icon.png);
}
.newsviews .views ul li>div>div>.artvisits{
  position: relative;
  display: inline-block;
  height: 15px;
  line-height: 15px;
  padding-left: 26px;
}
.newsviews .views ul li>div>div>.artvisits::before{
    content: '';
    display: inline-block;
    position: absolute;
    top: 1px;
    left: 0;
    width: 20px;
    height: 13px;
    background: url(/static/img/eye_icon.png);
}
.newsviews .views ul li>div>div>.writer{
  position: absolute;
  top:34px;
  right: 8px;

}
</style>
